<template>
  <div class="customer-ortho-elastics">
    <customer-show-ortho-elastic ref="showelastic" :customer="customer" @submit="loadElastics">
    </customer-show-ortho-elastic>

    <customer-show-ortho-arch ref="showarch" :customer="customer" @submit="loadArches">
    </customer-show-ortho-arch>

    <!-- ODONTOGRAM ROW -->
    <div class="customer-ortho-elastics__info">
      <strong>Selecciona hasta 4 Piezas con el ratón para resaltar los elásticos/arcos o crear uno nuevo</strong>
      <div>
        <transition name="fade">
          <button v-if="this.selected_tooth.length" @click="clearSelected" class="btn btn-wabident-round mx-1">
            <i class="fas fa-undo"></i> Borrar selección
          </button>
        </transition>
        <transition name="fade">
          <button v-if="this.selected_tooth.length" @click="createElastic" class="btn btn-wabident-round mx-1">
            <i class="fas fa-plus"></i>
            Crear Elástico
          </button>
        </transition>

        <transition name="fade">
          <button v-if="this.selected_tooth.length" @click="createArch" class="btn btn-wabident-round mx-1">
            <i class="fas fa-plus"></i>
            Crear Arco
          </button>
        </transition>
      </div>
    </div>

    <div class="customer-ortho-elastics__odontogram">
      <!-- GRAPH -->
      <customer-ortho-elastic-graph :elastics="ortho_elastics" :arches="arches"
        :selected_tooth="selected_tooth"></customer-ortho-elastic-graph>
      <!-- UPPER ROW -->
      <div class="customer-ortho-elastics__odontogram-row upper-row">
        <div v-for="tooth, index in upper_row_teeth" :key="index" :data-tooth="tooth" @click="clickTooth(tooth)"
          class="customer-ortho-elastics__odontogram-tooth upper"
          :class="{ selected: isSelected(tooth), extracted: extraction_map[tooth], bracketed: bracket_map[tooth] }">
          <!-- TOOTH IMAGE -->
          <img :src="'/odontogram-v2/' + tooth + '.svg'">
          <!-- BRACKET -->
          <div v-if="bracket_map[tooth]" class="customer-ortho-elastics__bracket upper">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
              <path d="M29,14H19V8c0-0.6-0.4-1-1-1s-1,0.4-1,1v6h-4V8c0-0.6-0.4-1-1-1s-1,0.4-1,1v6H1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h10v6
        c0,0.6,0.4,1,1,1s1-0.4,1-1v-6h4v6c0,0.6,0.4,1,1,1s1-0.4,1-1v-6h10c0.6,0,1-0.4,1-1C30,14.4,29.6,14,29,14z" />
            </svg>
          </div>
        </div>
      </div>
      <!-- LOWER ROW -->
      <div class="customer-ortho-elastics__odontogram-row lower-row">
        <div v-for="tooth, index in lower_row_teeth" :key="index" :data-tooth="tooth" @click="clickTooth(tooth)"
          class="customer-ortho-elastics__odontogram-tooth lower"
          :class="{ selected: isSelected(tooth), extracted: extraction_map[tooth], bracketed: bracket_map[tooth] }">
          <!-- TOOTH IMAGE -->
          <img :src="'/odontogram-v2/' + tooth + '.svg'">
          <!-- BRACKET -->
          <div v-if="bracket_map[tooth]" class="customer-ortho-elastics__bracket lower">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
              <path d="M29,14H19V8c0-0.6-0.4-1-1-1s-1,0.4-1,1v6h-4V8c0-0.6-0.4-1-1-1s-1,0.4-1,1v6H1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h10v6
        c0,0.6,0.4,1,1,1s1-0.4,1-1v-6h4v6c0,0.6,0.4,1,1,1s1-0.4,1-1v-6h10c0.6,0,1-0.4,1-1C30,14.4,29.6,14,29,14z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!-- ELASTIC LIST -->
    <b-tabs>
      <b-tab index="elastics" title="Elásticos">
        <div class="customer-ortho-elastics__list">
          <table class="table table-search-results">
            <thead>
              <tr>
                <th>Activo</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Piezas</th>
                <th>Largo</th>
                <th>Tensión</th>
                <th>Posición</th>
                <th>Tipo</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <customer-ortho-elastic @edit="editElastic" @delete="deleteElastic" :selected_tooth="selected_tooth"
                v-for="elastic in ortho_elastics" :key="elastic.id" :customer="customer"
                :elastic="elastic"></customer-ortho-elastic>
            </tbody>
          </table>
        </div>
      </b-tab>
      <b-tab index="arches" title="Arcos">
        <div class="customer-ortho-elastics__list">
          <table class="table table-search-results">
            <thead>
              <tr>
                <th>Activo</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Arco</th>
                <th>Calibre</th>
                <th>Material</th>
                <th>Tipo</th>
                <th>Numero</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <customer-ortho-arch @edit="editArch" @delete="deleteArch" :selected_tooth="selected_tooth"
                v-for="arch in arches" :key="arch.id" :customer="customer" :arch="arch"></customer-ortho-arch>
            </tbody>
          </table>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  props: ['customer'],
  data() {
    return {
      selected_tooth: [],
      upper_row_adults: [
        18, 17, 16, 15, 14, 13, 12, 11, // UPPER LEFT
        21, 22, 23, 24, 25, 26, 27, 28, // UPPER RIGHT
      ],
      lower_row_adults: [
        48, 47, 46, 45, 44, 43, 42, 41, // UPPER LEFT
        31, 32, 33, 34, 35, 36, 37, 38, // UPPER RIGHT
      ],
      elastics: [],
      arches: [],
    }
  },
  computed: {
    ortho_elastics() {
      return this.elastics;
    },
    extraction_map() {
      let ret = {};
      this.ortho_elastics.forEach((elastic) => {
        if (elastic.type != 'extraction' || !elastic.is_current) {
          return;
        }

        if (elastic.tooth_1) {
          ret[elastic.tooth_1] = true;
        }

        if (elastic.tooth_2) {
          ret[elastic.tooth_2] = true;
        }

        if (elastic.tooth_3) {
          ret[elastic.tooth_3] = true;
        }

        if (elastic.tooth_4) {
          ret[elastic.tooth_4] = true;
        }
      });
      return ret;
    },
    bracket_map() {
      let ret = {};
      this.ortho_elastics.forEach((elastic) => {
        if (elastic.type != 'bracket' || !elastic.is_current) {
          return;
        }

        if (elastic.tooth_1) {
          ret[elastic.tooth_1] = true;
        }

        if (elastic.tooth_2) {
          ret[elastic.tooth_2] = true;
        }

        if (elastic.tooth_3) {
          ret[elastic.tooth_3] = true;
        }

        if (elastic.tooth_4) {
          ret[elastic.tooth_4] = true;
        }
      });
      return ret;
    },
    upper_row_teeth() {
      return this.upper_row_adults;
    },
    lower_row_teeth() {
      return this.lower_row_adults;
    },
    ...mapGetters(['clinic', 'msgwindow', 'errorwindow'])
  },
  methods: {
    loadArches() {
      this.clearSelected();
      axios.get(`/customer/${this.customer.id}/arches`).then((response) => {
        this.arches = response.data;
      }).catch((err) => {
        this.msgwindow.error('Error cargando Arcos. Por favor contacte con el Administrador')
      });
    },
    loadElastics() {
      this.clearSelected();
      axios.get(`/customer/${this.customer.id}/elastics`).then((response) => {
        this.elastics = response.data;
      }).catch((err) => {
        this.msgwindow.error('Error cargando Elásticos. Por favor contacte con el Administrador')
      });
    },
    editElastic(elastic) {
      this.$refs.showelastic.showEdit(elastic);
    },
    editArch(arch) {
      this.$refs.showarch.showEdit(arch);
    },
    deleteElastic(elastic) {
      this.errorwindow.show('Confirmación', '¿Borrar el elástico? Esta operación no es reversible.', 'Borrar', 'Cancelar', () => {
        this.doDeleteElastic(elastic);
      })
    },
    deleteArch(arch) {
      this.errorwindow.show('Confirmación', '¿Borrar el arco? Esta operación no es reversible.', 'Borrar', 'Cancelar', () => {
        this.doDeleteArch(arch);
      })
    },
    doDeleteElastic(elastic) {
      axios.post(`/customer/${this.customer.id}/elastics/${elastic.id}`, {
        '_method': 'delete'
      }).then((response) => {
        this.msgwindow.success('Elástico borrado correctamente');
      }).catch((err) => {
        this.msgwindow.error('Error borrando el Elástico, consulte con el Administrador');
      }).then(() => {
        this.loadElastics();
      })
    },
    doDeleteArch(arch) {
      axios.post(`/customer/${this.customer.id}/arches/${arch.id}`, {
        '_method': 'delete'
      }).then((response) => {
        this.msgwindow.success('Arco borrado correctamente');
      }).catch((err) => {
        this.msgwindow.error('Error borrando el Elástico, consulte con el Administrador');
      }).then(() => {
        this.loadArches();
      })
    },
    clickTooth(tooth) {
      if (this.isSelected(tooth)) {
        this.selected_tooth = this.selected_tooth.filter((t) => {
          t != tooth;
        });
      } else {
        this.selected_tooth.push(tooth);
      }

      if (this.selected_tooth.length > 4) {
        this.selected_tooth.shift();
      }
    },
    clearSelected() {
      this.selected_tooth = [];
    },
    isSelected(tooth) {
      return this.selected_tooth.includes(tooth);
    },
    isExtracted(tooth) {
      return this.extraction_map[tooth] || false;
    },
    createElastic() {
      this.$refs.showelastic.showNew(this.selected_tooth);
    },
    createArch() {
      const arch = this.upper_row_adults.includes(this.selected_tooth[0]) ? 'upper' : 'lower';
      this.$refs.showarch.showNew(arch);
    },
  },

  mounted() {
    this.loadElastics();
    this.loadArches();
  }
}
</script>

<style lang="scss">
.customer-ortho-elastics {
  display: flex;
  flex-flow: column nowrap;
  gap: 30px;
  padding: 30px;

  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 36px;
  }

  &__bracket {
    position: absolute;
    width: 100%;
    max-width: 60px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);

    svg * {
      width: 100%;
      max-width: 60px;
      fill: var(--theme-text-color);
      transition: fill .3s;
    }

    &.upper {
      top: 75%;
    }

    &.lower {
      top: 25%;
    }
  }

  &__odontogram {
    width: 100%;
    position: relative;
    display: flex;
    flex-flow: row wrap;

    &:before {
      position: absolute;
      width: 100%;
      height: 1px;
      content: '';
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      background: var(--theme-shadow);
    }

    &:after {
      position: absolute;
      width: 1px;
      height: 100%;
      content: '';
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background: var(--theme-shadow);
    }
  }

  &__odontogram-row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 100%;
  }

  &__odontogram-tooth {
    flex: 1 1 60px;
    position: relative;
    cursor: pointer;
    transition: background-color .3s;
    border-radius: 10px;

    /* Selected background */
    &.selected,
    &:hover {
      background-color: var(--theme-shadow);
    }

    &.selected svg * {
      fill: var(--theme-color);
    }

    /* Tooth image */
    img {
      box-sizing: border-box;
      width: 100%;
      padding: 10%;
      object-fit: contain;
      object-position: center center;
    }

    &.extracted img {
      opacity: 0.1;
    }

    /* Tooth label */
    &::before {
      content: attr(data-tooth);
      position: absolute;
      left: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      color: white;
      font-weight: 900;
      font-size: clamp(7px, 0.7vw, 14px);
      line-height: 1.5;
      transform: translateX(-50%);
      padding: 0 5px;
      background-color: var(--theme-color);
      z-index: 1;
    }

    &.upper::before {
      top: 10px;
    }

    &.lower::before {
      bottom: 10px;
    }
  }

  &__list {
    margin-top: 10px;
    width: 100%;
    max-height: 50vh;
    overflow-y: scroll;

    table {
      thead {
        position: sticky;
        border-color: var(--theme-color);

        tr {
          background-color: var(--theme-color) !important;

          th {
            color: white;
            text-transform: uppercase;
            background-color: var(--theme-color);
            text-align: center;
            font-size: 15px;
          }
        }
      }

      tbody {
        tr {
          &.selected {
            background-color: var(--theme-shadow);
          }

          td {
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
